import React, { useMemo } from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { WhatsappContactContent, WhatsappContactProps } from './types';
import { TRUCKER_SUPPORT_NUMBER } from '@/constants';

export type truckTypes = 'noRegistered' | 'noSelfIsValid' | 'noUpdateNeeded';

const SUPPORT_CONTACT = `Se encontrar alguma dificuldade, clique no número: ${TRUCKER_SUPPORT_NUMBER} para solicitar ajuda à Fretebras.`;

export const WhatsappContact: React.FC<WhatsappContactProps> = ({ cellPhone, type, cpf, fullWidth = true }) => {
  const messages: Record<truckTypes, WhatsappContactContent> = {
    noRegistered: {
      message: `Olá, para que a gente possa continuar a negociação, preciso que você se cadastre na Fretebras. Lá você também consegue encontrar mais fretes e ter mais segurança. Baixe o aplicativo pelo link: https://play.google.com/store/apps/details?id=br.lgfelicio. ${SUPPORT_CONTACT}`,
      text: 'Convidar motorista',
    },
    noSelfIsValid: {
      message: `Olá, para que a gente possa continuar a negociação, preciso que você atualize sua selfie no aplicativo da Fretebras. Basta acessar “Perfil” → ”Meus dados e documentos” e atualizar sua Selfie: https://play.google.com/store/apps/details?id=br.lgfelicio. ${SUPPORT_CONTACT}`,
      text: 'Solicitar ao motorista',
    },
    noUpdateNeeded: {
      message: `Olá, tenho algumas dúvidas sobre a pesquisa do motorista ${cpf} no Gerenciamento de Risco da Fretebras. Pode me ajudar?`,
      text: 'Enviar Whatsapp',
    },
  };
  const currentData = useMemo(() => ({ ...messages[type] }), [type]);

  const href = useMemo(
    () => `https://api.whatsapp.com/send?phone=55${cellPhone}&text=${currentData.message}`,
    [cellPhone, currentData],
  );

  return (
    <FuelButton target="_blank" fullWidth={fullWidth} size="large" variant="whatsapp" href={href}>
      {currentData.text}
    </FuelButton>
  );
};
